import type { ParseKeys } from 'i18next';

export type SignUpMethodName = 'google' | 'microsoft' | 'email';

const SignUpMethodNameList = ['google', 'microsoft', 'email'] as const satisfies readonly SignUpMethodName[];

export namespace SignUpMethodName {
  export function values(): SignUpMethodName[] {
    return [...SignUpMethodNameList];
  }

  export function getLocalStringKey(methodName: SignUpMethodName): ParseKeys {
    switch (methodName) {
      case 'google':
        return 'group.signUpMethod.google';
      case 'microsoft':
        return 'group.signUpMethod.microsoft';
      case 'email':
        return 'group.signUpMethod.email';
    }
  }
}
